import { render, staticRenderFns } from "./PopupShare.vue?vue&type=template&id=6c2228c4&scoped=true&"
import script from "./PopupShare.vue?vue&type=script&lang=js&"
export * from "./PopupShare.vue?vue&type=script&lang=js&"
import style0 from "./PopupShare.vue?vue&type=style&index=0&id=6c2228c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2228c4",
  null
  
)

export default component.exports